export const indexedAnnuityCareBrief = `**OneAmerica Indexed Annuity Care** - single-premium fixed indexed annuity with a
base LTC Benefit Balance (LTCBB) plus an optional Continuation of Benefits (COB)
rider.

Pool model - **two annuity LTC pools, drawn sequentially**:
- \`base_pool\` is the base annuity **LTC Benefit Balance** extracted from the
  Guaranteed Rates row at expected LTC start. Monthly cap comes from that same
  row's LTC Monthly Withdrawal Limit (daily cap = monthly / 30).
- \`eob\` is the **COB Rider LTC Balance**. It is seeded from
  \`policyContinuationBenefitAmountAtIssue\` / \`policyContinuationBenefitAmount\`
  when present. Monthly cap grows by \`policyInflationProtectionOnCOBAmount\`
  when elected.
- \`db\` may carry residual annuity **Account Value** only when that value is
  extracted. If no residual Account Value is supplied, it remains $0.

Payout model - reimbursement:
- Eligible care is reimbursed up to actual cost and the active pool's daily cap.
- Base LTCBB pays first. Once base is exhausted, COB pays at the COB monthly
  limit. Split months expose both \`baseBenefitDays\` and \`cobBenefitDays\` in
  strategy deltas.
- 60-day elimination period, days out-of-pocket. No retroactive lump.

Ground truth - extraction:
- Use the Account Value Summary Based on Guaranteed Rates table, not the Current
  or Non-Guaranteed table.
- Extract LTC Benefit Balance and LTC Monthly Withdrawal Limit from the row for
  expected LTC-start annuitant age, or the closest lower displayed age.
- COB issue balance comes from the Base Annuity + COB summary.

Limitations:
- The strategy does not reverse-engineer Account Value or Cash Surrender Value
  schedules. Those are unnecessary for LTC payout math when the Guaranteed Rates
  LTCBB and monthly limit are extracted directly.
`;
